import Dialog from './Dialog.vue'

export default {
  install(Vue) {
    Vue.component(Dialog.name, Dialog)
  }
}
